import { Pipe, PipeTransform } from '@angular/core';
import { IAttachment } from '../models/attachments.model';
import { AttachmentService } from '../service/attachments.service';

@Pipe({
  name: 'isPreviewable',
  standalone: false,
})
export class IsPreviewablePipe implements PipeTransform {
  private previewableTypes = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];

  transform(attachment: IAttachment): boolean {
    if (!attachment) {
      return false;
    }

    return this.previewableTypes.includes(AttachmentService.resolveAttachmentType(attachment));
  }
}
